import moment from "moment"

import { IEmployee } from "api/querries/useGetEmployees"

import { Text } from "@chakra-ui/react"

export const getNestedColumns = (T: any, locale: string,) => {

  const washerRoleID = "526bb32c-8dc5-4535-95bc-788c61df609b"
  return [
    {
      key: "დაწყების თარიღი",
      render: (data: IEmployee) => (
        <>
          <Text>{T("employees.table.columns.start_date")}:</Text>
          <Text fontWeight="600">{moment(data.startDate).locale(locale).format("DD MMMM YYYY") || " - "}</Text>
        </>
      ),
      styles: {
        width: "35%"
      }
    },
    {
      key: "შესრულებული რეცხვა",
      render: (data: IEmployee) => (
        <>
          <Text>{T("employees.table.columns.total_wash_count")}:</Text>
          <Text fontWeight="600">{data.totalWashCount}</Text>
        </>
      ),
      styles: {
        width: "45%"
      }
    },
    {
      key: "washer_salary",
      render: (data: IEmployee) => {
        if (data?.roleId === washerRoleID) {
          return (
            <>
              <Text>{T("employees.table.columns.washer_salary")}:</Text>
              <Text fontWeight="600">{`${data?.salaryPercent} %`}</Text>
            </>
          )
        }
        return

      },
      styles: {
        width: "45%"
      }
    },
    {
      key: "რეცხვის საშუალო დრო",
      render: (data: IEmployee) => (
        <>
          <Text>{T("employees.table.columns.average_wash_time")}:</Text>
          <Text>{data.averageWashTime || " - "}</Text>
        </>
      ),
      styles: {
        width: "18%",
      },
    },
  ]
}